import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconCodeBrackets: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconCodeBrackets"><Path fillRule="evenodd" clipRule="evenodd" d="M15.1706 3.22378L10.2759 21.1709L8.82875 20.7762L13.7234 2.8291L15.1706 3.22378ZM6.80984 7.71788L2.7796 12L6.80984 16.2821L5.71754 17.3102L0.719727 12L5.71753 6.68984L6.80984 7.71788ZM18.2818 6.68984L23.2796 12L18.2818 17.3102L17.1895 16.2821L21.2197 12L17.1895 7.71788L18.2818 6.68984Z" fill="currentColor"/></CentralIconBase>;
});

export default IconCodeBrackets;
